import React from "react";
import * as styles from "./Video.module.css";

const VideoPlayer = ({ props }) => (
  <div
  // data-aos="zoom-in"
  // data-aos-duration="400"
  >
    <div className={styles.videoResponsive}>
      <iframe
        width="853"
        height="480"
        src={`https://www.youtube.com/embed/${props.youTubeVideoId}?rel=0`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={props.videoTitle}
        loading="lazy"
      />
    </div>
  </div>
);

export default VideoPlayer;
